import { FC, useEffect, useState } from "react"
import ReactLoading from "react-loading"
import './index.css'
import { useParams } from "react-router-dom"
import { AdditionalType, ItemFractionalType } from "../../../contexts/OrderContext";
import { centsToFloat, floatToPrice } from "../../../functions/price_functions";
import { cpfMask, datetimeToDateBR, datetimeToDatetimeBR, telephoneToMask } from "../../../functions/mask";
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";

import box from '../../../assets/images/box.svg'
import check from '../../../assets/images/check.svg'
import canceled from '../../../assets/images/circle-xmark.svg'
import pix from '../../../assets/images/Pix.svg'



type ProductOrderType = {
    id: number;
    name: string;
    quantity: number;
    unitPrice: number;
    promotionalPrice: number;
    variation: string;
    fractions: ItemFractionalType[];
    additionals: AdditionalType[];
};

export type OrderFindedType = {
    id: number;
    ext: string;
    date: string;
    observation: string;
    type: string;
    status: Array<StatusResponseType>;
    allStatus: Array<StatusResponseType>;
    store: string;
    address: string;
    user: any;
    products: ProductOrderType[];
    totalValue: number;
    freight: number;
    statusId: number;
    content: any;
    discount: number
    payment: any
};

type StatusResponseType = {
    id: number;
    name: string;
    slug: string;
    order: number;
    displayStatusWebapp: boolean;
    colorSetting?: {};
};

type ProductResponseType = {
    id: number;
    code: string;
    content: any;
    sku: string;
    price: number;
    quantity: number;
    discount: number;
};

type PluginspaceResponseType = {
    name: string;
};

type OrderResponseType = {
    id: number;
    classifierId: number | null;
    content: any;
    statusId: number;
    created: string;
    customerId: string;
    deliveryTax: number;
    discountGeral: number;
    locationId: number;
    orderidExt: string;
    pluginconfigId: number;
    pluginspaceId: number;
    products: Array<ProductResponseType>;
    status: Array<StatusResponseType>;
    type: string;
    pluginspace: PluginspaceResponseType;
    observation: string;
    discountGeneral: any
};


type status = {
    content: string
    icon: any
    color: string
}

const OrderDetails: FC = () => {
    const [loading, setLoading] = useState(false)

    const { ext } = useParams()
    const { getToken } = usePluginspace();

    const [order, setOrder] = useState<OrderFindedType>()
    const [status, setStatus] = useState<status>({
        color: '',
        content: '',
        icon: ''
    })


    const getOrderDetails = async () => {

        setLoading(true);
        await api
            .post(
                `/api/orders/ext/${ext}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${await getToken()}`,
                    },
                }
            )
            .then((response: { data: any; }) => {
                const orderResponse = response.data;
                console.log(orderResponse.data[0])

                const newOrders = orderResponse.data.map(
                    (order: OrderResponseType) => {
                        let orderAddress = null;
                        let payment = null;
                        if (order.content && order.content.orderAddress) {
                            orderAddress = order.content.orderAddress;
                        }


                        let totalValue = 0;
                        order.products.map((product) => {
                            totalValue += product.price * product.quantity;
                        });


                        if (order.content && order.content.dataGateway) {
                            payment = {
                                date: datetimeToDatetimeBR(order.content.dataGateway.dateTime),
                                total: centsToFloat(totalValue),
                                type: order.content.dataGateway.typeTicket
                            }
                        }
                        return {
                            id: order.id,
                            ext: order.orderidExt,
                            date: datetimeToDateBR(order.created),
                            type: order.type,
                            observation: order.observation,
                            statusId: order.statusId,
                            status: order.status.sort((a, b) => a.order - b.order),
                            allStatus: [],
                            store: order.pluginspace
                                ? order.pluginspace.name
                                : (orderAddress.name ? orderAddress.name : ""),
                            address: orderAddress ? (`${orderAddress.address} - ${orderAddress.district
                                } - ${orderAddress.city} - ${orderAddress.cep ? orderAddress.cep : ""
                                }`) : '',
                            user: {
                                name: (order.content && order.content.customer) ? order.content.customer : '',
                                cpf: (order.content && order.content.customerCpf) ? cpfMask(order.content.customerCpf) : '',
                                phone: (order.content && order.content.phoneSms) ? telephoneToMask(order.content.phoneSms) : '',
                                email: (order.content && order.content.customerEmail) ? order.content.customerEmail : '',
                            },
                            products: order.products.map((product) => ({
                                id: product.id,
                                name: product.content.productName,
                                quantity: product.quantity,
                                unitPrice: centsToFloat(
                                    product.price + product.content.discount
                                ),
                                promotionalPrice: centsToFloat(
                                    product.price
                                ),
                                fractions: product.content && product.content.fractionated ? product.content.fractionated : [],
                                additionals: product.content && product.content.additionals ? product.content.additionals : [],
                                variation: product.content.variation
                                    ? JSON.parse(product.content.variation)
                                    : {},
                            })),
                            totalValue: centsToFloat(totalValue),
                            freight: (order.content && order.content.deliveryFee)
                                ? centsToFloat(order.content.deliveryFee)
                                : 0,
                            content: order.content,
                            discount: centsToFloat(order.discountGeneral),
                            totalOrderValue: centsToFloat(order.discountGeneral) + totalValue + centsToFloat(order.discountGeneral),
                            payment: payment
                        };
                    }
                );
                setOrder(newOrders[0]);
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
                console.log(err);
                return null;
            });

    }


    const traduzType = (value: string) => {
        if (value === 'withdraw') {
            return 'Retirada na loja'
        }

        return 'Entrega'
    }

    const traduzPaymentType = (value: string) => {
        if (value === 'payOffline') {
            return 'Pagamento no dinheiro'
        }

        else if (value === 'pix') {
            return 'Pix'
        }
        else
        return 'Cartão'
    }

    const getStatus = () => {
        try {
            const auxStatus = order!.status[0]
            const back: any = auxStatus.colorSetting


            const status = {
                icon: '',
                content: '',
                color: ''
            }

            if (auxStatus.slug === 'a') {
                status.content = 'Cancelado: o pedido foi cancelado.'
                status.color = back.background ? back.background : '#EB5353'
                status.icon = canceled
            } else if (auxStatus.slug === 'b') {

                status.content = 'Concluído: o pedido foi entregue.'
                status.color = back.background ? back.background : '#67BF5F'
                status.icon = check
            } else {
                status.content = 'Em preparo: seu pedido está sendo preparado.'
                status.color = back.background ? back.background : '#40A7E0'
                status.icon = box
            }


            setStatus(status)

        } catch (error) {
            return error
        }

    }


    useEffect(() => {
        getOrderDetails()
        getStatus()
    }, [])


    return (
        <div className="mainPageOrderDetails">
            {loading ? (
                <>
                    <ReactLoading
                        type={"spin"}
                        color={"#b5b5b5"}
                        height={20}
                    />
                </>
            ) : (
                <div className="contentOrdersDetails">
                    {order && (
                        <>
                            <div className="resume">
                                <div className="headerResume">
                                    <span>Pedido {order.id}</span>
                                </div>
                                <div className="body">
                                    <div className="details">
                                        <span>Valor dos produtos</span>
                                        <span>{floatToPrice(order.totalValue)}</span>
                                    </div>
                                    <div className="details">
                                        <span>Descontos</span>
                                        <span>{floatToPrice(order.discount)}</span>
                                    </div>
                                    <div className="details">
                                        <span>Taxa de Entrega</span>
                                        <span>{floatToPrice(order.freight)}</span>
                                    </div>
                                    <div className="details">
                                        <h3>Total da Compra</h3>
                                        <h3>{floatToPrice(order.totalValue)}</h3>
                                    </div>
                                    <div className="status" style={{ backgroundColor: status.color }}>
                                        <img src={status.icon} alt="" />
                                        <span>

                                            {
                                                status.content
                                            }</span>
                                    </div>
                                </div>
                            </div>
                            <div className="resume">
                                <div className="headerResume">
                                    <span>Meus Dados</span>
                                </div>
                                <div className="body">
                                    <div className="details">
                                        <span>{order.user.name}</span>
                                        <span>{order.user.cpf}</span>
                                    </div>
                                    <div className="details">
                                        <span>{order.user.email}</span>
                                        <span>{order.user.phone}</span>

                                    </div>
                                    <div className="details">
                                        <span>{ }</span>
                                    </div>
                                </div>
                            </div>
                            <div className="resume">
                                <div className="headerResume">
                                    <span>Forma de entrega</span>
                                </div>
                                <div className="body">
                                    <div className="detailsPagamento">
                                        <span>{traduzType(order.type)}</span>
                                    </div>
                                    <div className="details">
                                        <span>{order.address}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="resume">
                                <div className="headerResume">
                                    <span>Pagamento</span>
                                </div>
                                <div className="body">
                                    <div className="details">
                                        {traduzPaymentType(order.payment.type) == 'Pix' && (
                                            <img src={pix} alt="" />
                                        )

                                        }
                                        <span>{traduzPaymentType(order.payment.type)}</span>
                                    </div>
                                    <div className="details">
                                        <span>Realizado em {order.payment.date}</span>
                                    </div>
                                    <div className="details">
                                        <span>{`Valor: ${floatToPrice(order.payment.total)}`}</span>
                                    </div>
                                </div>
                            </div>

                        </>
                    )

                    }
                </div>
            )

            }
        </div>
    )
}

export { OrderDetails }